import AbstractWidget from "@/models/WebsiteWidget/AbstractWidget";
import WebsiteWidget from "@/models/WebsiteWidget/WebsiteWidget";

export default class Title extends AbstractWidget {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'website-widget/title';

    /**
     *
     * @type {string}
     */
    static entity = 'websiteWidgetTitles';

    static model_name = 'Title';

    /**
     * Relations used for normalization
     * @returns {{}}
     */

    static fields() {
		return {
			id: this.attr(null),
			display_type: this.attr(null),
			title: this.attr(null),
			link_text: this.attr(null),
			link_url: this.attr(null),
			created_at: this.attr(null),
			updated_at: this.attr(null),
			website_route_id: this.attr(null),
            widget: this.hasOne(WebsiteWidget, 'widgetable_id'),
		}
	}

    /**
     *
     * @returns {*}
     * @constructor
     */
    Widget() {
        return WebsiteWidget.byWidgetable(this.WidgetTemplate().key, this.id);
    }

}
